import { isStaging, isDev } from 'constants/api';

import instantiateCueAnalytics from '@cuemath/analytics';

export const CONFIG = {
  env: isStaging || isDev ? 'development' : 'production',
  debug: false,
  product: 'leap_student',
};
const cueAnalytics = instantiateCueAnalytics(CONFIG);

export default cueAnalytics;
